import { useQuery } from "react-query";
import { DivisiResponse } from "../../../../models/Divisi";
import { getApiInstance } from "../../../api";
import queryWrapper from "../../queryWrapper";
import ApiClient from "../../../apiClient";

export const fetchAllDivisiKey = "all-divisi-key";

export async function fetchAllDivisi(): Promise<DivisiResponse[]> {
  const res = await ApiClient.get(`/AllDivisi`);
  return res.data;
}

export default function useFetchAllDivisi() {
  return useQuery([fetchAllDivisiKey], queryWrapper(fetchAllDivisi));
}
